<template>
    <main class="flex min-h-100%">
        <SideBar :is-collapsed="isSidebarCollapsed" />
        <div class="tw-transition-all tw-duration-[500ms]" :class="['pagev2', { active: isSidebarCollapsed }]">
            <NavBar @toggle-sidebar="toggleSidebar" />
            <slot></slot>
            <FooTer />
        </div>
    </main>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FooTer from "../../ui/v2/FooTer.vue";
import NavBar from "../../ui/v2/NavBar.vue";
import SideBar from "../../ui/v2/SideBar.vue";
export default {
    name: "MainLayout",
    components: {
        SideBar,
        NavBar,
        FooTer,
    },
    computed: {
        ...mapState('ui', ['isSidebarCollapsed']),
    },
    methods: {
        ...mapActions('ui', ['toggleSidebar']),
    }
};
</script>
<style scoped>
@tailwind base;
@tailwind components;
@tailwind utilities;
.pagev2 {
    min-height: 102vh;
    padding-bottom: 0em;
}
</style>
